// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1dPy7","title":"BackImages_title__2V0n9","images":"BackImages_images__LxfOQ"};